// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"072257f4-168":"9cd213ec7121fc196874","072257f4-794":"62884aba53d31f19803c","072257f4-735":"35620f52e569246b41c0","072257f4-91":"9419bafdc3d4d8b04eae"}[chunkId] + ".js";
};